import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, MapPin, ArrowUpRight } from 'lucide-react';
import { companyInfo } from '../../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Services', path: '/services' },
    { name: 'Insights', path: '/insights' },
    { name: 'Podcasts', path: '/podcasts' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Privacy Policy', path: '/PrivacyPolicy' },
    { name: 'Terms & Conditions', path: '/Terms&Condition' },
  ];

  const services = [
    'Content Marketing',
    'Social Media Marketing',
    'Brand Building',
    'Thought Leadership',
    'Digital Presence',
  ];

  const serviceSlug = (text) =>
  text.toLowerCase().replace(/\s+/g, "-");

  return (
    <footer className="bg-navy text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Main Footer */}
        <div className="py-16 lg:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Brand Column */}
            <div className="lg:col-span-1">
              <img
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="h-10 w-auto mb-6 brightness-0 invert"
              />
              <p className="text-gray-400 text-sm leading-relaxed mb-6">
                {companyInfo.description}
              </p>
              <div className="flex items-center space-x-3">
                <a
                  href={companyInfo.linkedIn}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                  aria-label="LinkedIn"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                  aria-label="Email"
                >
                  <Mail className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-6">
                Quick Links
              </h4>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-gray-300 hover:text-white transition-colors text-sm flex items-center group"
                    >
                      {link.name}
                      <ArrowUpRight className="w-3 h-3 ml-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-6">
                Services
              </h4>
              <ul className="space-y-3">
                {services.map((service) => (
                  <li key={service}>
                    <Link to={`/services#${serviceSlug(service)}`}>
                    <span className="text-gray-300 text-sm">{service}</span>
                  </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-6">
                Contact
              </h4>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-gray-500 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300 text-sm">{companyInfo.address}</span>
                </div>
                <div className="flex items-start space-x-3">
                  <Mail className="w-5 h-5 text-gray-500 flex-shrink-0 mt-0.5" />
                  <a
                    href={`mailto:${companyInfo.email}`}
                    className="text-gray-300 hover:text-white transition-colors text-sm"
                  >
                    {companyInfo.email}
                  </a>
                </div>
              </div>

              <div className="mt-8">
                <Link to="/contact" className="cta-button !bg-white !text-navy hover:!bg-gray-100 text-sm">
                  Let's Connect
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <p className="text-gray-500 text-sm">
              Organic Marketing for Investment Firms
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
